module.exports = __webpack_public_path__ + "img/intelligentsia1.2d390ed1.jpg";